<template>
    <section class="gh-section gh-unprecedented gh-bg-blue">
        <div class="container">
            <div>
                <h3 class="gh-section-heading gh-white">An Unprecedented Body of Knowledge</h3>
                <el-row :gutter="gutter">
                    <el-col :span="24" :md="12">
                        <p class="gh-text gh-white pb-1">The Summit brings together an unprecedented body of knowledge on suicidology and suicide prevention.</p>
                        <p class="gh-text gh-white pb-1">Mental health practitioners have this extraordinary opportunity to learn global best-practice strategies to treat and manage suicidal behaviour.</p>
                        <p class="gh-text gh-white pb-1">The 2021 Suicide Prevention Summit is streamed direct to your computer. <span v-show="windowWidth < 991">All you need is an internet (preferably broadband) connected device with speakers to access the highest-quality CPD training available anywhere.</span></p>
                    </el-col>

                    <el-col :span="24" :md="12">
                        <p  v-show="windowWidth >= 991" class="gh-text gh-white pb-1">All you need is an internet (preferably broadband) connected device with speakers to access the highest-quality CPD training available anywhere.</p>
                        <p class="gh-text gh-white pb-1">And if you can’t attend the event in real-time (we understand you have a busy schedule), you can access recorded session content after the live event, on-demand (24/7), until October 10.</p>
                    </el-col>
                </el-row>
            </div>
        </div>
    </section>
</template>
<script>
    import windowSizeMixin from '@/modules/events/suicidePreventionSummit/mixins/windowSize'
    import UX from '@/utils/ux';

    export default {
        mixins: [windowSizeMixin],

        data() {
            return {
                desktopPinScene: new ScrollMagic.Scene({triggerHook: 0, reverse: true}),
            }
        },

        methods: {
            scrollToSection(section) {
                const element = document.getElementById(section);

                element && UX.scrollTo(element);

                this.$emit('clicked');
            }
        },

        computed: {
            gutter () {
                return this.windowWidth <= 1024 ? 0 : 50
            }
        }
    }
</script>
<style scoped lang="scss">
    .gh-section {
        padding-bottom: 5rem;
    }
    .el-row {
        margin-top: .5rem;
        width: 100%;
    }

    p {
        font-size: 1.4rem;
        line-height: 1.2;
        font-weight: 500;

        + p {
            margin-top: 1.5rem;
        }

        @media (max-width: 1199px) {
            font-size: 1.15rem;
        }
        @media (max-width: 991px) {
            font-size: 1.4rem;
        }
    }
</style>
